module.exports = __webpack_public_path__ + "img/resped-logo.5da55f6e.svg";